module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0ff4db9010c97c4facbdb1301e29d13a.png";